// Separate admin roles. Owner (scope "all") sees every panel; "carwash" admins only Admin; "extra" admins only Extra Service; "jobs" admins only Franchise & Jobs.
export const adminScope = (user) => (user && (user.is_admin || user.role === "admin") ? (user.admin_scope || "all") : "");
export const canSeeAdminPanel = (user) => { const s = adminScope(user); return s === "all" || s === "carwash"; };
export const canSeeJobsPanel = (user) => { const s = adminScope(user); return s === "all" || s === "jobs"; };
export const canSeeExtraPanel = (user) => {
  const s = adminScope(user);
  if (s) return s === "all" || s === "extra";
  return !!user && ["staff", "technician"].includes(user.role);
};
/** Where to land right after login: single-panel admins go straight to their own panel. */
export const postLoginPath = (user) => { const s = adminScope(user); return s === "jobs" ? "/admin/jobs" : s === "extra" ? "/admin/extra-services" : s === "carwash" ? "/admin" : "/dashboard"; };
